'use strict';


/*Object.defineProperty(exports, "__esModule", {
  value: true
});*/

function Stripe (){
	this.products = [];
	this.options = {forceVerify: true};
	this.parent = null
	
	
this.init = function(opt, products, parent){
	this.parent = parent;
		Object.assign(this.options,opt);
		if(this.options.validator != null && this.options.validator != undefined && this.options.validator != ''){
	this.validator = this.options.validator;			
		}
	this.products = products;		
	return true;		
}
this.getProducts = function (){
	return this.products;
}
this.doCheckout = function(productsSelected, couponData, cb) {
	var arr = [];
	var params = {};
	if (productsSelected.pastOrder != undefined && productsSelected.pastOrder != null && productsSelected.pastOrder != ''){
	params.pastOrder = productsSelected.pastOrder;
	}else{ 
	for( var k in productsSelected){
		arr.push(productsSelected[k].id);
	}
	params = {products: arr.join(';')};
	if(couponData != undefined && couponData != '' && couponData !=  null){
		params.couponCode = couponData.code;
	}
	}
	this.parent.callService('api/store/doCheckout', params, (result) => {
		cb(result.data);
	});	
}
this.getCheckoutForm = function (options, cb) {
	var productsStr = '';
	if(options.products != undefined && options.products!=null){
	if(options.products.length > 0) {
	var productsStr = options.products.join(',');		
	}
	}
	this.parent.callService('api/store/getCheckoutForm', {products: productsStr}, function (r) {
	cb(r.data);	
	});
}
this.updateValidatorURL = function (url) {
	this.validator = url;
} 

};

module.exports = Stripe;
